module.exports = __webpack_public_path__ + "img/財富_四方連續_線稿_black.5bd5e089.png";